import { render, staticRenderFns } from "./StoryEditorFloatToolbar.vue?vue&type=template&id=6d06c20a&scoped=true&"
import script from "./StoryEditorFloatToolbar.vue?vue&type=script&lang=js&"
export * from "./StoryEditorFloatToolbar.vue?vue&type=script&lang=js&"
import style0 from "./StoryEditorFloatToolbar.vue?vue&type=style&index=0&id=6d06c20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d06c20a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
